import { AxiosResponse } from 'axios'
import { api } from '../config'

export type AddPartnerRequest = {
  email: string
  events: {
    eventId: string
    revenuePercent: number
  }[]
}

export const addPartnerInEvent = async (request: AddPartnerRequest) => {
  const { status }: AxiosResponse = await api.patch(
    '/api/creators/partners/events',
    request
  )

  return status
}
